import React, { Component } from 'react';

import withStyles from '@material-ui/core/styles/withStyles';
import {Animation, EventTracker,HoverState,} from '@devexpress/dx-react-chart';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid, Paper, Typography, TextField } from '@material-ui/core';

import { authMiddleWare } from '../util/auth';

import functionsApi from '../api';
import moment from 'moment';

import {
	Chart,
	ArgumentAxis,
	ValueAxis,
	Title,
	LineSeries,
	Legend,
	Tooltip
} from '@devexpress/dx-react-chart-material-ui';

const makeLabel = (symbol) => ({ text, style, ...restProps }) => (
	<ValueAxis.Label
	  text={`${symbol}${text}`}
	  style={{
		...style
	  }}
	  {...restProps}
	/>
  );

  const makeDateLabel = () => ({ text, style, ...restProps }) => (
	<ValueAxis.Label
	  text={`${moment(text, "YYYYMMDD").format("DD")}`}
	  style={{
		...style
	  }}
	  {...restProps}
	/>
  );

const PriceLabel = makeLabel("$");
const DateLabel = makeDateLabel();

const styles = (theme) => ({
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	},
	toolbar: theme.mixins.toolbar,
	details: {
		display: 'flex'
	},
	avatar: {
		height: 110,
		width: 100,
		flexShrink: 0,
		flexGrow: 0
	},
	locationText: {
		paddingLeft: '15px'
	},
	buttonProperty: {
		position: 'absolute',
		top: '50%'
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	progess: {
		position: 'absolute'
	},
	uploadButton: {
		marginLeft: '8px',
		margin: theme.spacing(1)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	submitButton: {
		marginTop: '10px'
    },
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
	},
	textField: {
		margin: '10px'
	},
	currentPeriodDot: {
		height: '15px',
		width: '15px',
		backgroundColor: '#bbb',
		borderRadius: '50%',
		display: 'inline-block'
	},
	previousPeriodDot: {
		height: '15px',
		width: '15px',
		backgroundColor: '#bbb',
		borderRadius: '50%',
		display: 'inline-block'
	}
      
});

/**
 * Calculates in percent, the change between 2 numbers.
 * e.g from 1000 to 500 = 50%
 * 
 * @param oldNumber The initial value
 * @param newNumber The value that changed
 */
function getPercentageChange(oldNumber, newNumber){
    var decreaseValue = oldNumber - newNumber;

    return (decreaseValue / oldNumber) * 100;
}

class dashboard extends Component {

	constructor(props) {
		super(props);

		this.state = {
			name: '',
			email: '',
			phoneNumber: '',
			country: '',
			profilePicture: '',
			socialNetworks: [],
			contents: [],
			spokenLanguages: [],
			uiLoading: true,
			buttonLoading: false,
			imageError: '',
			startDate: moment().startOf('month').format('YYYYMMDD'), 
			previousPeriodStartDate: moment().subtract(1,'months').startOf('month').format('YYYYMMDD'),
			endDate: moment().endOf('month').format('YYYYMMDD'), 
			previousPeriodEndDate: moment().subtract(1,'months').endOf('month').format('YYYYMMDD'), 
			numberOfViews: "",
			numberOfViewsPreviousPeriod: "",
			valuePerDayData: [],
			valuePerDayPreviousPeriodData: [],
			sumData: [],
		};
	}

	componentWillMount = () => {
		authMiddleWare(this.props.history);
		functionsApi
			.get('/getTrainerDetail')
			.then((response) => {
				this.setState({
					name: response.data.userCredentials.name,
					email: response.data.userCredentials.email,
					phoneNumber: response.data.userCredentials.phoneNumber,
					country: response.data.userCredentials.country,
                    id: response.data.userCredentials.id,
                    isActive: response.data.userCredentials.isActive,
					socialNetworks: response.data.userCredentials.socialNetworks,
					contents: response.data.userCredentials.contents,
					spokenLanguages: response.data.userCredentials.spokenLanguages,
				},
				this.getNumberOfViews
				);

			})
			.catch((error) => {
				this.props.history.push('/login');
				this.setState({ errorMsg: 'Error in retrieving the data', uiLoading: false });
			});

	};

	getNumberOfViews = () => {
		
		functionsApi
		.get('/getNumberOfViews', {
			params: {
			  trainerID: this.state.id,
			  startDate: this.state.startDate,
			  endDate: this.state.endDate
			}
		})
		.then((response) => {
			functionsApi.get('/getNumberOfViews', {
				params: {
				  trainerID: this.state.id,
				  startDate: this.state.previousPeriodStartDate,
				  endDate: this.state.previousPeriodEndDate
				}
			}).then((response2) => {

				var sum1 = 0
				var sum2 = 0
		
				const sumValues = response2.data.map((l, i) => {
		
					sum1 = (sum1 || 0) + l.viewsCount
					if (response.data[i]) {
						sum2 = (sum2 || 0) + response.data[i].viewsCount
						return {date: l.date, sum: sum1 * 0.03, sum2: sum2 * 0.03, viewCount: l.viewsCount, viewCount2: response.data[i].viewsCount}
					} else {
						return {date: l.date, sum: sum1 * 0.03, sum2: sum2 * 0.03, viewCount: l.viewsCount, viewCount2: 0}
					}	
				});

				var sum = response.data.map( v => v.viewsCount ).reduce( (sum, current) => sum + current, 0 );
				var sum2 = response2.data.map( v => v.viewsCount ).reduce( (sum, current) => sum + current, 0 );
				
				this.setState({
					numberOfViews: sum,
					numberOfViewsPreviousPeriod: sum2,
					sumData: sumValues,
					uiLoading: false
				});
			}).catch((error) => {
				this.setState({ errorMsg: 'Error in retrieving the data', uiLoading: false });
			});
		})
		.catch((error) => {
			if (error.response.status === 401 || error.response.status === 403) {
				this.props.history.push('/login');
			}
			this.setState({ errorMsg: 'Error in retrieving the data', uiLoading: false });
		});
	}

	handleStartDateChange = (event) => {
		this.setState({
			startDate: moment(event.target.value, "YYYY-MM-DD").format("YYYYMMDD"),
			previousPeriodStartDate: moment(event.target.value, "YYYY-MM-DD").subtract(1,'months').format("YYYYMMDD")
		},
		this.getNumberOfViews
		);
		
	};

	handleEndDateChange = (event) => {
		this.setState({
			endDate: moment(event.target.value, "YYYY-MM-DD").format("YYYYMMDD"),
			previousPeriodEndDate: moment(event.target.value, "YYYY-MM-DD").subtract(1,'months').format("YYYYMMDD")
		},
		this.getNumberOfViews
		);
	};

	renderNumberOfViews() {
		const { classes } = this.props;
		if (this.state.isActive && this.state.numberOfViews !== "") {
			return <Paper className={classes.paper}>
				<form className={classes.container} noValidate>
					<TextField
					id="date"
					label="Start Date"
					type="date"
					defaultValue={moment(this.state.startDate, "YYYYMMDD").format("YYYY-MM-DD")}
					className={classes.textField}
					onChange={this.handleStartDateChange}
					InputLabelProps={{
						shrink: true,
					}}
					/>
					<TextField
					id="date"
					label="End Date"
					type="date"
					defaultValue={moment(this.state.endDate, "YYYYMMDD").format("YYYY-MM-DD")}
					className={classes.textField}
					onChange={this.handleEndDateChange}
					InputLabelProps={{
						shrink: true,
					}}
					/>
			</form>

			<Grid container alignItems="center" justify="center" spacing={1}>
			<Typography variant="h6">Revenue per selected period vs previous period: </Typography>
				<Grid item >
					<Typography variant="h5" align="center" color="textSecondary">${(this.state.numberOfViews * 0.03).toFixed(2)}</Typography>
				</Grid>
				<Grid item >
					<p style={{color: Math.sign(getPercentageChange(this.state.numberOfViews, this.state.numberOfViewsPreviousPeriod).toFixed(2)) === -1 ? "red" : "green"}}>
						{getPercentageChange(this.state.numberOfViews, this.state.numberOfViewsPreviousPeriod).toFixed(2)}%
					</p>
				</Grid>
			</Grid>
			<Grid container alignItems="center" justify="center" spacing={1}>
			<Typography variant="h6">Total Revenue:</Typography>
			<Grid item>
			<Typography variant="h5" align="center" color="textSecondary">${(this.state.numberOfViewsPreviousPeriod * 0.03).toFixed(2)}</Typography>
			</Grid>
			</Grid>
			<Grid container spacing={4}>
				<Grid item md={6} xs={12}>
					<Paper>
					<Chart data={this.state.sumData} indentFromAxis={5} showLabels>
						<ArgumentAxis labelComponent={DateLabel} showLine showTicks showLabels/>
						<ValueAxis showLine showTicks showLabels/>
						<Title text="Daily views"/>
						<LineSeries name="Selected Period" valueField="viewCount2" argumentField="date" color="#1476FF"/>
						<LineSeries name="Previous Period" valueField="viewCount" argumentField="date"  color="#44D7B6"	/>
						<Legend/>
						<EventTracker />
          				<HoverState />
						<Animation/>
						<Tooltip />
					</Chart>
					</Paper>
				</Grid>
				<Grid item md={6} xs={12}>
				<Paper>
					<Chart data={this.state.sumData} indentFromAxis={5}>
						<ArgumentAxis labelComponent={DateLabel} showLine showTicks showLabels/>
						<ValueAxis labelComponent={PriceLabel} showLine showTicks showLabels/>
						<Title text="Total Revenue"/>
						<LineSeries name="Current Period" valueField="sum2" argumentField="date" color="#1476FF"/>
						<LineSeries name="Previous Period" valueField="sum" argumentField="date" color="#44D7B6"/>
						<Legend/>
						<EventTracker />
          				<HoverState />
						<Animation/>	
						<Tooltip />
					</Chart>
					</Paper>
				</Grid>
			</Grid>
		  </Paper>
		} else {
			if (this.state.uiLoading === true) {
				return <CircularProgress className={classes.uiProgess} />
			} else {
				return <Grid/>
			}
		}
	}

	render() {
		const { classes } = this.props;
		console.log("this.state.uiLoading")
		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					<div className={classes.toolbar} />
					{this.state.uiLoading && <CircularProgress className={classes.uiProgess} />}
				</main>
			);
		} else {
			return (
                <main className={classes.content}>
                    <div className={classes.toolbar} />
                    <div className={classes.root}>
                        <Grid container alignItems="center" justify="center" spacing={4}>
                            <Grid item xs={12}>
                                <Typography variant="h6" color="textPrimary">Hi, {this.state.name}</Typography>
                            </Grid>
                            <Grid item sm={12}>
                                <Paper className={classes.paper}>
                                    <Typography variant="body1" align="left" color="textSecondary">Your account is {this.state.isActive ? "active" : "inactive"},</Typography>
                                    <Typography variant="body1" align="left" color="textSecondary">{this.state.isActive ? "you can now start to post workouts" : "we will notify you once your account becomes active"}</Typography>
                                </Paper>
                            </Grid>
							<Grid item xs={12}>
								{this.renderNumberOfViews()}
							</Grid>
                        </Grid>
                    </div>
                </main>
			);
		}
	}
}

export default withStyles(styles)(dashboard);
